"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * A StepList is a segmented display that can be used to indicate progress within a multi-step process.
 */
const StepList = props => {
  const {
    activeStep,
    detailedStepper,
    subtitle,
    stepTitle,
    steps
  } = props;
  let stepItems = [];
  let maxActiveStep = activeStep;
  if (maxActiveStep > steps) maxActiveStep = steps;
  for (let i = 1; i <= steps; i++) {
    stepItems.push( /*#__PURE__*/_react.default.createElement("li", {
      "aria-current": maxActiveStep === i ? 'step' : null,
      className: maxActiveStep === i ? 'active' : null,
      key: i
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, "Step ", i), detailedStepper ? /*#__PURE__*/_react.default.createElement("p", null, stepTitle[i - 1]) : ''));
  }
  if (subtitle) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("ul", {
      className: "mm-stepper"
    }, stepItems), /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-stepper-subtitle"
    }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "mm-desktop-tablet-only"
    }, "Step ", maxActiveStep, " of ", steps, " |", ' '), subtitle)));
  } else {
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: `${detailedStepper ? 'mm-stepper--detailed' : 'mm-stepper'}`
    }, stepItems);
  }
};
var _default = exports.default = StepList;
StepList.defaultProps = {
  steps: 1
};
StepList.propTypes = {
  /** Set the active step */
  activeStep: _propTypes.default.number,
  /** Set to true for the detailed stepper */
  detailedStepper: _propTypes.default.bool,
  /** Set the number of steps displayed */
  steps: _propTypes.default.number.isRequired,
  /** A subtitle describing the current step */
  subtitle: _propTypes.default.string,
  /** Set an array of individual titles - one title for each step */
  stepTitle: _propTypes.default.arrayOf(_propTypes.default.string)
};